export default ({ $auth }) => {
  if ($auth?.loggedIn) $auth.fetchUser();
};
